<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Resit Perbendaharaan iSPEKS">



            <!-- <w-form > -->
                <w-flex class="mt3">
                    <div class="xs4 mr3">
                       <w-input
                        type="date"
                        label="Tarikh Fail"
                        name="tarikh_tansaksi"
                        v-model="form.tarikh_fail">
                       </w-input>
                    </div>

                    <div class="mt3">
                    &nbsp;
                     <w-button class="ml1 " @click="detail()" :loading="form.loading" bg-color="warning">
                        <w-icon>fas fa-file-import</w-icon>&nbsp;Import
                    </w-button>
                </div>
                    
                </w-flex>
            <!-- </w-form> -->
            <br><br><br>

           

            

            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>           
            
            <z-table ref="tbluser" title="Fail Rsp iSPEKS" :headers="table.headers" :items="table.items" :meta="table.meta" class="">

               <template #item-cell.butiran="{ item }">
    <div v-for="(butiran, index) in item.butiran" :key="index">
        {{ butiran.no_penyata_pemungut }}
    </div>
</template>
                
                 <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        &nbsp;
                        <w-checkbox v-model="pilih" @click="cekPilih"></w-checkbox>
                    </template>
                    <template v-else>
                         {{ label }}
                    </template>
                </template>


                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">
                   &nbsp;
                        <template v-if="item.status == 0">
                             <w-checkbox v-model="item.pilih"></w-checkbox>
                        </template>
                  </w-flex>
                </template>
            </z-table>

            <div class="mt2 text-right">
                <w-button bg-color="success" class="mr3" @click="hantar">
                    &nbsp;Proses
                </w-button>
               
            </div>

        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan +'penyata_pemungut/senarai_perbendaharaan',
        reload: true,
        loading: true,
        form:{
            loading: false,
            tarikh_fail: '',},
        cari : {
            // loading: false,
            tarikh_fail: '',
        },
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Kutipan', route: '/kutipan' },
            { label: 'Penyata Pemungut', route: 'kutipan.penyata_pemungut.index' },
            { label: 'Resit Perbendaharaan iSPEKS', route: 'kutipan.penyata_pemungut.senarai_perbendaharaan' }

          ],

        pilih : false
           
        }
         
  },
  methods: {
        
        detail() {

            this.showOverlay = true
            this.form.loading = true

            this.$zcomm
                .post(
                    this.service_kutipan + "penyata_pemungut/import_perbendaharaan",
                    this.form
                )
                .then((res) => {
                    const msg = res.data?.message || "Berjaya"

                    this.$zutil.notify(msg)

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                    }

                })
                .catch((err) => {
                    const msg = err.response?.data?.message || "Ralat sistem"

                    this.loadData()
                })
                .finally(() => {
                    this.showOverlay = false
                    this.form.loading = false

                    this.loadData()
                })
        },

        loadData() {
            this.$zcomm
                .get(this.service_kutipan + "penyata_pemungut/senarai_perbendaharaan")
                .then((res) => {
                    this.table.items = res.data.items
                })
        },

        cekPilih(){
        
            for (var i in this.table.items) {
                this.table.items[i].pilih = this.pilih
            }
        },

         hantar() {
            var id = '';
            for (var i in this.table.items) {
                if(this.table.items[i].pilih == true){
                    id = this.table.items[i].id+','+id
                }
            }
            if(id){
                 this.$zcomm
                .post(this.service_kutipan + "penyata_pemungut/processed_perbendaharaan/" +id)
                .then((res) => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }

                    this.$zutil.notify ("Penyata Pemungut Telah Berjaya Dihantar");
                    this.loadData()
                  })
                  .catch(err => {

                  })
                  .finally(() => {

                  });
            }else{
                alert('sila pilih dulu.')
            }
        },

        
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 900
    
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>